import React, { useState } from 'react'
import { getDashboardUserSessionReports } from '../../../../../store/dashboard/actions'
import { SessionsCount } from '../../../../../store/dashboard/reducer'
import { useTranslation } from 'react-i18next'
import UsageTrendsChartView from './UsageTrendsChartView'
import { useQuery } from '@tanstack/react-query'
import { getAgentFromStorage } from '@/utils/appUtils'

interface UsageTrendsChartProps {
  filtersData?: any
  isOrganisation?: boolean
}

const UsageTrendsChart = ({
  filtersData,
  isOrganisation,
}: UsageTrendsChartProps) => {
  const { t } = useTranslation('translation')
  const [frequency, setFrequency] = useState({
    value: 'daily',
    label: t('Daily'),
  })

  const agentId = getAgentFromStorage()

  const { isLoading, data } = useQuery({
    queryKey: [
      isOrganisation ? 'organisation-usage-trends' : 'usage-trends',
      filtersData,
      frequency.value,
      isOrganisation,
      agentId,
    ],
    enabled: !!(filtersData.filter_from_date && filtersData.filter_to_date),
    queryFn: async () => {
      const data = await getDashboardUserSessionReports({
        filtersData: { ...filtersData, type: frequency.value },
        isOrganisation,
      })
      const barChartData: SessionsCount[] = [
        ...data.activeUsersSessions.map((d: any) => {
          return {
            ...d,
            type: 'usageTrends',
          }
        }),
      ]
      const key1 = 'session_count',
        key2 = 'user_count'

      const result: number = Math.max.apply(
        Math,
        barChartData.map(function (a) {
          return Math.max(a[key1], a[key2])
        }),
      )

      return { maxValue: result, sessionsData: barChartData }
    },
  })

  return (
    <UsageTrendsChartView
      loading={isLoading}
      sessionsData={data?.sessionsData || []}
      filtersData={filtersData}
      frequency={frequency}
      maxValue={data?.maxValue || 0}
      onFrequencyChange={setFrequency}
      isOrganisation={isOrganisation}
    />
  )
}

export default UsageTrendsChart
